import { loadModal } from '../../AsyncLoader';
import SyosPageComponent from '../components/SyosPageComponent';
import SyosEvents from '../utils/SyosEvents';

/** @typedef {import('../SyosController').default} SyosController */
/** @typedef {import('../SyosSeat').default} SyosSeat */

function getBodyContents(seat) {
  return `
    ${SyosPageComponent.removeSeatConfirmationMessage}
    <p>Row: ${seat.row}, Seat: ${seat.number}</p>
  `;
}

/**
 * @param {SyosController} syosController
 * @param {SyosSeat} seat
 * @param {HTMLElement} $returnFocusTo
 */
async function confirm(syosController, seat, $returnFocusTo) {
  const Modal = await loadModal();

  return new Promise((resolve) => {
    Modal.confirm({
      title: SyosPageComponent.removeSeatConfirmationTitle,
      labelBtnConfirm: SyosPageComponent.removeButton,
      labelBtnCancel: SyosPageComponent.cancelButton,
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      bodyContents: getBodyContents(seat),
      returnFocusTo: $returnFocusTo,
      describedById: 'tn-syos-remove-seat-confirmation-modal-content',
      beforeRemove: () => {
        syosController.emit(SyosEvents.MODAL_CLOSE);
      },
    });
  });
}

export default {
  confirm,
};
